import Link from "next/link";
import { StockLogo } from "@/components/stock-logo";
import { cn } from "@/lib/utils";

export interface PillStock {
  symbol: string;
  name: string;
  logoUrl?: string;
  score: number;
}

function scoreTone(score: number): string {
  if (score >= 66) return "text-positive";
  if (score >= 33) return "text-gold-text";
  return "text-negative";
}

export function StockPillList({
  label,
  stocks,
  compact = false,
}: {
  label: string;
  stocks: PillStock[];
  /** Engerer Vertikalbedarf für Platzierungen direkt im Hero-Bereich (Feedback-Runde
   * 18 Punkt 12: "CommunityTrends" soll direkt unter die Suchleiste, Preisbundles
   * müssen trotzdem ohne Scrollen sichtbar bleiben) - kleinere Pills/Logos/Abstände
   * statt der regulären Größe weiter unten auf der Seite. */
  compact?: boolean;
}) {
  return (
    <div className={cn("reveal flex w-full max-w-2xl flex-col items-center", compact ? "gap-1.5" : "gap-3")}>
      <span className="text-xs font-medium uppercase tracking-[0.15em] text-muted-foreground">
        {label}
      </span>
      <div className={cn("flex flex-wrap justify-center", compact ? "gap-2" : "gap-2.5")}>
        {stocks.map((s) => (
          <Link
            key={s.symbol}
            href={`/${encodeURIComponent(s.symbol)}`}
            className={cn(
              "group flex items-center rounded-full border border-hairline bg-card shadow-sm transition-all hover:-translate-y-0.5 hover:border-gold hover:shadow-md",
              compact ? "gap-2 py-1 pl-1.5 pr-3" : "gap-2.5 py-1.5 pl-2 pr-4",
            )}
          >
            <StockLogo symbol={s.symbol} logoUrl={s.logoUrl} size={compact ? 20 : 24} bordered={false} />
            <span className={cn("text-ink", compact ? "text-xs" : "text-sm")}>{s.name}</span>
            <span className={cn("font-tabular font-medium", compact ? "text-xs" : "text-sm", scoreTone(s.score))}>
              {Math.round(s.score)}
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
}
